export enum ActiveReportFilters {
     DEFAULT = 'default',
     CAR_MODEL = 'carModel',
     DEPOTS = 'depots',
     SUPPLIERS = 'suppliers',
     RADIUS = 'radius',
     DURATION = 'duration',
     SEATS = 'seats'
}
